import React from 'react';
import { Box, Typography } from '@mui/material';
import { motion } from 'framer-motion';

/**
 * Consistent section header used across pages:
 * eyebrow (overline) + title + accent underline + optional subtitle.
 */
const SectionHeading = ({
  eyebrow,
  title,
  subtitle,
  align = 'center',
  light = false,
  sx,
}) => {
  const isCenter = align === 'center';
  return (
    <motion.div
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
    >
      <Box
        sx={{
          textAlign: align,
          maxWidth: subtitle ? 760 : 'none',
          mx: isCenter ? 'auto' : 0,
          ...sx,
        }}
      >
        {eyebrow && (
          <Typography
            variant="overline"
            sx={{
              display: 'inline-block',
              color: light ? 'rgba(255,255,255,0.85)' : 'primary.main',
              mb: 1.5,
            }}
          >
            {eyebrow}
          </Typography>
        )}
        <Typography
          variant="h2"
          sx={{
            color: light ? '#fff' : 'text.primary',
            mb: 2.5,
          }}
        >
          {title}
        </Typography>
        <Box
          sx={{
            width: 64,
            height: 4,
            borderRadius: 2,
            background: light
              ? 'rgba(255,255,255,0.7)'
              : 'linear-gradient(90deg, #1565C0, #FF7A45)',
            mx: isCenter ? 'auto' : 0,
            mb: subtitle ? 3 : 0,
          }}
        />
        {subtitle && (
          <Typography
            variant="body1"
            sx={{
              color: light ? 'rgba(255,255,255,0.8)' : 'text.secondary',
              fontSize: '1.1rem',
              maxWidth: 680,
              mx: isCenter ? 'auto' : 0,
            }}
          >
            {subtitle}
          </Typography>
        )}
      </Box>
    </motion.div>
  );
};

export default SectionHeading;
